import { CloseOutlined } from '@mui/icons-material';
import { Box, CircularProgress, Drawer, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { tokens } from 'theme/tokens';
import FormElements from './FormElements';
import ToastHandler from './Toast-Handler/toast-handler';

const FormDrawer = ({
  open,
  title,
  toast,
  isProcessing,
  children,
  footer,
  handleClose, 
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const drawerWidth = theme.custom.drawerWidth;
  // Determine current breakpoint
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 640px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 640px - 1054px
  const isLaptop = useMediaQuery(theme.breakpoints.between('md', 'lg')); // 1054px - 1280px
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // > 1280px
  
  // Resolve drawer width
  let width = drawerWidth.xs;
  if (isTablet) width = drawerWidth.xs;
  if (isLaptop) width = drawerWidth.md;
  if (isDesktop) width = drawerWidth.lg;

  return (
    /* Desktop-7 (Figma Design) */
    <Drawer
      anchor={'right'}
      open={open}
      variant='temporary'
      onClose={handleClose}
      ModalProps={{
        keepMounted: false,
        style: { left: 'auto' }
      }}
      slotProps={{
        paper: {
          sx: {
            width: width,
            height: '100%',
            maxWidth: drawerWidth.maxWidth,
            p: 3,
            px: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
          }
        }
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '9px',
          alignSelf: 'stretch',
        }}
      >
        {/* Main Content */}
        <Box
          height='calc(100vh - 40px - 80px)'
          p={4.5}
          py={0}
          flexDirection={'column'}
          alignItems={'center'}
          alignSelf={'stretch'}
          gap={3}
        >
          {/* HEADER */}
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'flex-start'}
            alignSelf={'stretch'}
            mb={1}
          >
            <Typography variant='h4' sx={{ fontWeight: 600 }}>{title}</Typography>
            <IconButton size='small' sx={{border: `1px solid ${colors.red[200]}`}} onClick={handleClose}><CloseOutlined sx={{color: colors.red[300]}} /></IconButton>
          </Box>
          {/* CONTENT */}
          <Box display={'block'} textAlign={'center'}>
            {isProcessing && <CircularProgress style={{ width: 40, height: 40 }} />}
            {toast && toast.type ? <ToastHandler toast={toast} type={toast.type} /> : ''}
          </Box>
          <FormElements.FormContainer>
            {children}
          </FormElements.FormContainer>
        </Box>
        {/* Footer */}
        {footer}
      </Stack>
    </Drawer>
  );
};

export default FormDrawer;